import { AxiosInstance } from "axios";
import { conciliatorGateway } from "../domain/conciliator.gateway";
import { paths } from "./keys";
import { ConciliationResponse, ConciliatorFilter, HistoryReconciliation, HistoryReconciliationFilters, IServiceInfo, IServiceInfoResponse } from "../domain/conciliator.entity";

export class conciliatorHttpGateway implements conciliatorGateway {
  constructor(private http: AxiosInstance) { }

  async process(ids: number[]): Promise<void> {
    return await this.http.post<void>(paths.process, {
      ids,
    }).then((response) => response.data);
  }

  async getListConciliator(filters: ConciliatorFilter): Promise<ConciliationResponse> {
    return await this.http.get(paths.getListConciliator, {
      params: filters,
    }).then((response) => response.data);
  }

  async getReconciliationsHistory(filters: HistoryReconciliationFilters): Promise<HistoryReconciliation[]> {
    return await this.http.get(paths.getReconciliationsHistory, {
      params: filters,
    }).then((response) => response.data);
  }

  async getServiceInfo(): Promise<IServiceInfo[]> {
    return await this.http
      .get<IServiceInfoResponse>(paths.getServiceInfo)
      .then((response) => response.data.services);
  }
}